module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productSlider"
  }, [_c('div', {
    staticClass: "sliderWrapper"
  }, [_c('div', {
    staticClass: "container2"
  }, [_c('section', {
    staticClass: "main-photo"
  }, _vm._l((_vm.items), function(item) {
    return (item.img) ? _c('div', {
      staticClass: "item",
      style: (("background-image: url(" + (item.img) + ")"))
    }, [_c('a', {
      staticClass: "full-screen",
      attrs: {
        "data-fancybox": "group",
        "href": item.img
      }
    }, [_c('svg', {
      attrs: {
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
      }
    })])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "container1"
  }, [_c('section', {
    staticClass: "horizont-slider"
  }, _vm._l((_vm.items), function(item) {
    return (item.img) ? _c('div', {
      staticClass: "itm"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-67f8416d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/slickSlider.vue
// module id = 330
// module chunks = 22